import { history } from 'umi';
import { DBSystemCode, SYSTEM_INFO, ENV, IS_GLOBAL } from '@home/_config/config';

import type { TDBSystemCode } from '@home/types/aiSearch';

export const changeURLStatic = (urlStr: string) => {
  if (!urlStr) {
    return;
  }

  // if (urlStr.startsWith('/datalab')) {
  //   history.push(urlStr);
  //   return;
  // }
  //
  // if (urlStr.startsWith('/dashboard')) {
  //   history.push(urlStr);
  //   return;
  // }

  // // 情报系统
  // if (urlStr.startsWith('/intelligence')) {
  //   if (SYSTEM_INFO.intelligence[ENV]) {
  //     history.push(URL_MAP[urlStr] || urlStr);
  //   } else {
  //     window.open(urlStr);
  //   }
  //   return;
  // }

  // 舆情系统
  // if (urlStr.startsWith('/opinion')) {
  //   if (SYSTEM_INFO.opinion[ENV]) {
  //     history.push(URL_MAP[urlStr] || urlStr);
  //   } else {
  //     window.open(urlStr);
  //   }
  //   return;
  // }

  // 舆情系统
  if (urlStr.startsWith('/g-pop')) {
    if (SYSTEM_INFO.globalpedia[ENV]) {
      history.push(URL_MAP[urlStr] || urlStr);
    } else {
      window.open(urlStr);
    }
    return;
  }

  history.push(urlStr);
};

export const URL_MAP = {} as any;

// 默认情报路径为Topchart-pc
export const getDefaultDBIPath = () => {
  if (IS_GLOBAL) {
    return `/intelligence/topCharts/pcGames`;
  }
  return `/intelligence/topCharts/mobileGames`;
};

// 首页情报卡片标题跳转
export const newReleaseUpcommingPath = {
  'Mobile_New Release': '/intelligence/potential/newReleaseGames/MobileGames',
  Mobile_Upcoming: '/intelligence/potential/upcomingGames/MobileGames',
  'PC_New Release': '/intelligence/potential/newReleaseGames/PCGames',
  PC_Upcoming: '/intelligence/potential/upcomingGames/PCGames',
  'Console_New Release': '/intelligence/potential/newReleaseGames/ConsoleGames',
  Console_Upcoming: '/intelligence/potential/upcomingGames/ConsoleGames',
} as any;

// 首页Data Sources路径跳转配置
export const dataSourcesPath = {
  appannie: '/intelligence/topCharts/mobileGames',
  sensortower: '/intelligence/topCharts/mobileGames',

  mscience: '/intelligence/topCharts/pcGames/DigitalRevenue',
  newzoo: '/intelligence/topCharts/pcGames/MAU',
  npd: '/intelligence/topCharts/pcGames/PhysicalRevenue',

  appstore: '/intelligence/storeRanks/MobileGlobalRegion/AllTopCharts',
  googleplay: '/intelligence/storeRanks/MobileGlobalRegion/AllTopCharts',
  steam: '/intelligence/storeRanks/PCGlobal/steam',
  epic: '/intelligence/storeRanks/PCGlobal/epic',
  xbox: '/intelligence/storeRanks/ConsoleRegion/xbox',
  playstation: '/intelligence/storeRanks/ConsoleRegion/playstation',
  nintendo: '/intelligence/storeRanks/ConsoleRegion/nintendo',

  youtube: '/intelligence/streaming/games',
  twitch: '/intelligence/streaming/games',
  fbgaming: '/intelligence/streaming/games',
  hatchet: '/intelligence/streaming/games',

  crunchbase: '/intelligence/topCharts/companies/Revenue',
  famitsu: '/intelligence/topCharts/consoleGames/JapanSales',
  vginsights: '/intelligence/topCharts/pcGames/SteamSales',
  // bilibili
  // databarin
  // taptap
} as any;

/**
 * 首页 Data Sources 静态有序配置（权威来源：TAPD #1120427644135228125 需求表）。
 * - 顺序、中英 hover 文案、跳转路径均前端写死，不依赖后端返回顺序/文案。
 * - 已移除 VG insights（与 VGI 停止合作）。
 * - path 为站内相对路径（含 query），由 changeURLStatic/history.push 在当前域名下跳转，
 *   天然适配 woa / global / test 各环境，无需按 hostname 拼绝对域名。
 * - iconType 对应 getImgs 的 DataSourceIcon type（小写）。
 * - 与情报数据源概览页 intelligence 子仓 dataSourceList 内容保持一致。
 */
export interface HomeDataSourceItem {
  iconType: string;
  hoverZh: string;
  hoverEn: string;
  path: string;
}

export const homeDataSources: HomeDataSourceItem[] = [
  {
    iconType: 'sensortower',
    hoverZh: '数据来源：Sensor Tower\n点击查看排行榜-手游',
    hoverEn: 'Data Source: Sensor Tower\nClick to view Top Charts-Mobile',
    path: '/intelligence/topCharts/mobileGames?chart_type=bar&source=sensortower&sort_name=dau&ratio_type=0&order=desc',
  },
  {
    iconType: 'databrainbluebg',
    hoverZh: '数据来源：Databrain 校准数据\n点击查看排行榜-端游 & 主机游戏',
    hoverEn: 'Data Source: Databrain Calibrated Data\nClick to view Top Charts-PC&Console',
    path: '/intelligence/topCharts/pcConsoleGames/DataBrainCalibration',
  },
  {
    iconType: 'mscience',
    hoverZh: '数据来源：Mscience\n点击查看排行榜-端游 & 主机游戏',
    hoverEn: 'Data Source: Mscience\nClick to view Top Charts-PC&Console',
    path: '/intelligence/topCharts/pcConsoleGames/MetricsTable',
  },
  {
    iconType: 'alinea',
    hoverZh: '数据来源：Alinea Analytics\n点击查看排行榜-端游 & 主机游戏',
    hoverEn: 'Data Source: Alinea Analytics\nClick to view Top Charts-PC&Console',
    path: '/intelligence/topCharts/pcConsoleGames/MetricsTable',
  },
  {
    iconType: 'appstore',
    hoverZh: '数据来源：iOS App Store\n点击查看商店排行-手游全球/地区',
    hoverEn: 'Data Source: iOS App Store\nClick to view Store Ranks-Mobile Global/Region',
    path: '/intelligence/storeRanks/MobileGlobalRegion/AllTopCharts?store=appstore',
  },
  {
    iconType: 'googleplay',
    hoverZh: '数据来源：Google Play\n点击查看商店排行-手游全球/地区',
    hoverEn: 'Data Source: Google Play\nClick to view Store Ranks-Mobile Global/Region',
    path: '/intelligence/storeRanks/MobileGlobalRegion/AllTopCharts?store=googleplay',
  },
  {
    iconType: 'steam',
    hoverZh: '数据来源：Steam\n点击查看商店排行-PC游戏全球',
    hoverEn: 'Data Source: Steam\nClick to view Store Ranks-PC Global',
    path: '/intelligence/storeRanks/PCGlobal/steam',
  },
  {
    iconType: 'gsd',
    hoverZh: '数据来源：GSD\n点击查看排行榜-端游 & 主机游戏',
    hoverEn: 'Data Source: GSD\nClick to view Top Charts-PC&Console',
    path: '/intelligence/topCharts/pcConsoleGames/MetricsTable',
  },
  {
    iconType: 'xbox',
    hoverZh: '数据来源：Xbox\n点击查看商店排行-主机游戏地区',
    hoverEn: 'Data Source: Xbox\nClick to view Store Ranks-Console Region',
    path: '/intelligence/storeRanks/ConsoleRegion/xbox',
  },
  {
    iconType: 'ampere',
    hoverZh: '数据来源：Other Vendor\n点击查看排行榜-端游 & 主机游戏',
    hoverEn: 'Data Source: Other Vendor\nClick to view Top Charts-PC&Console',
    path: '/intelligence/topCharts/pcConsoleGames/MetricsTable',
  },
  {
    iconType: 'data.ai',
    hoverZh: '数据来源：data.ai\n点击查看排行榜-手游',
    hoverEn: 'Data Source: data.ai\nClick to view Top Charts-Mobile',
    path: '/intelligence/topCharts/mobileGames?chart_type=bar&source=appannie&sort_name=dau&ratio_type=0&order=desc',
  },
  {
    iconType: 'crunchbase',
    hoverZh: '数据来源：Crunchbase\n点击查看公司-收入',
    hoverEn: 'Data Source: Crunchbase\nClick to view Company Revenue',
    path: '/intelligence/topCharts/companies/Revenue?chart_type=bar&sort_name=total_revenue&order=desc&ratio_type=0',
  },
  {
    iconType: 'npd',
    hoverZh: '数据来源：NPD\n点击查看排行榜-端游',
    hoverEn: 'Data Source: NPD\nClick to view Top Charts-PC',
    path: '/intelligence/topCharts/pcGames/PhysicalRevenue',
  },
  {
    iconType: 'playstation',
    hoverZh: '数据来源：PlayStation\n点击查看商店排行-主机游戏地区',
    hoverEn: 'Data Source: PlayStation\nClick to view Store Ranks-Console Region',
    path: '/intelligence/storeRanks/ConsoleRegion/playstation',
  },
  {
    iconType: 'nintendo',
    hoverZh: '数据来源：Nintendo\n点击查看商店排行-主机游戏地区',
    hoverEn: 'Data Source: Nintendo\nClick to view Store Ranks-Console Region',
    path: '/intelligence/storeRanks/ConsoleRegion/nintendo',
  },
  {
    iconType: 'epic',
    hoverZh: '数据来源：Epic Games Store\n点击查看商店排行-主机游戏地区',
    hoverEn: 'Data Source: Epic Games Store\nClick to view Store Ranks-Console Region',
    path: '/intelligence/storeRanks/PCGlobal/epic',
  },
  {
    iconType: 'hatchet',
    hoverZh: '数据来源：Hatchet\n点击查看直播-游戏',
    hoverEn: 'Data Source: Hatchet\nClick to view Streaming',
    path: '/intelligence/streaming/games?subTab=hoursWatched',
  },
  {
    iconType: 'twitch',
    hoverZh: '数据来源：Twitch\n点击查看直播-游戏',
    hoverEn: 'Data Source: Twitch\nClick to view Streaming',
    path: '/intelligence/streaming/influencer',
  },
  {
    iconType: 'fbgaming',
    hoverZh: '数据来源：FB Gaming\n点击查看直播-游戏',
    hoverEn: 'Data Source: FB Gaming\nClick to view Streaming',
    path: '/intelligence/streaming/influencer',
  },
  {
    iconType: 'youtube',
    hoverZh: '数据来源：YouTube\n点击查看直播-游戏',
    hoverEn: 'Data Source: YouTube\nClick to view Streaming',
    path: '/intelligence/streaming/influencer',
  },
];

// 数据地图跳转路径
export const datamapOverviewPath = '/intelligence/sourcesMetrics/overview';
export const datamapMobileGameFieldsPath = '/intelligence/sourcesMetrics/metrics/MobileGameFields';
export const datamapPCConsoleFieldsPath = '/intelligence/sourcesMetrics/metrics/PCConsoleFields';
export const datamapIntelligenceSourcesPath =
  '/intelligence/sourcesMetrics/sources/IntelligenceSources';
export const datamapIntelligenceMetricsPath =
  '/intelligence/sourcesMetrics/metrics/IntelligenceMetrics';
export const datamapOpinionsMetricsPath = '/intelligence/sourcesMetrics/metrics/OpinionsMetrics';

/** 获取游戏类型对应Url名称 */
export const getGameTypeUrlName = (type: string) => {
  let urlName = '';
  switch (type) {
    case 'pc':
      urlName = 'PCGames';
      break;
    case 'mobile':
      urlName = 'MobileGames';
      break;
    case 'console':
      urlName = 'ConsoleGames';
      break;
    default:
      break;
  }
  return urlName;
};

// 报告跳转路径
export const reportOverviewPath = '/intelligence/reports/reportSearch';

/**
 * Serializes common URL parameter values into a string representation.
 * Handles empty values, strings, and arrays of strings.
 *
 * @param value - The value to serialize. Can be a string, string array, null, or undefined.
 * @returns Serialized string representation of the input value:
 *   - Empty string for falsy values (null/undefined/empty)
 *   - Original string for string inputs
 *   - Comma-separated string for arrays
 */
export const serializeCommonValue = (value?: string | string[] | null): string => {
  // Handle empty/falsy cases: null, undefined, or empty string
  if (!value) return '';

  // Return directly if it's a single string
  if (typeof value === 'string') return value;

  // Convert string arrays to comma-separated strings
  if (Array.isArray(value)) return value.join(',');

  // Fallback for unexpected types (shouldn't occur with TypeScript typing)
  return value;
};

/**
 * 给URL追加查询参数，支持相对路径和绝对路径
 *
 * @param baseUrl - 基础URL字符串（可以是相对路径如'/path'或绝对路径）
 * @param params - 要添加的查询参数对象
 * @returns 追加了查询参数的完整URL字符串（保持原始URL类型）
 */
export const appendSearchParams = (baseUrl: string, params: IRecord): string => {
  if (!baseUrl) return '';
  // 处理空参数情况
  if (!params || Object.keys(params).length === 0) {
    return baseUrl;
  }

  // 创建URL对象时使用当前页面URL作为基础
  const urlObj = new URL(baseUrl, window.location.href);

  // 遍历参数对象，添加到URL的查询参数中
  Object.entries(params).forEach(([key, value]) => {
    // 对参数值进行序列化和编码
    if (value) {
      urlObj.searchParams.set(key, value);
    }
  });

  // 根据原始URL类型返回相应格式
  if (baseUrl.startsWith('/')) {
    // 返回相对路径格式：/path?param=value
    return urlObj.pathname + urlObj.search;
  } else if (baseUrl.includes('://')) {
    // 返回完整绝对路径：https://domain.com/path?param=value
    return urlObj.toString();
  } else {
    // 返回相对路径格式：path?param=value
    return urlObj.pathname.substring(1) + urlObj.search;
  }
};

/** DataBrain 站点常用基础路径前缀 */
const DATABRAIN_BASE_PATHS = ['v2', 'rebuildv2'];

/** DataBrain 子系统 path code 归一映射 */
const DATABRAIN_SYSTEM_CODE_MAP: Record<string, string> = {
  home: DBSystemCode.Home,
  search: DBSystemCode.Home,
  chatgpt: DBSystemCode.Home,
  'region-select': DBSystemCode.Home,
  'access-code-login': DBSystemCode.Home,
  login: DBSystemCode.Home,
  intelligence_detail: DBSystemCode.Home,
  dashboard: DBSystemCode.Dashboard,
  datalab: DBSystemCode.Datalab,
  intelligence: DBSystemCode.Intelligence,
  opinion: DBSystemCode.Opinions,
  opinions: DBSystemCode.Opinions,
  marketing: DBSystemCode.Marketing,
  'g-pop': DBSystemCode.Globalpedia,
  gpop: DBSystemCode.Globalpedia,
  globalpedia: DBSystemCode.Globalpedia,
  strategic: DBSystemCode.Mgmt,
  mgmt: DBSystemCode.Mgmt,
  studio: DBSystemCode.StudioHub,
  studiohub: DBSystemCode.StudioHub,
  benchmark: DBSystemCode.Benchmark,
  'user-center': DBSystemCode.UserCenter,
  usercenter: DBSystemCode.UserCenter,
};

/** DataBrain 收藏 URL 白名单域名 */
const DATABRAIN_HOSTNAMES = [
  // 正式环境
  'databrain.woa.com',
  'databrain-global.woa.com',
  'databrain-global.intlgame.com',
  'databrain.intlgame.com',
  'databrain-mobile.intlgame.com',
  // 预发布环境
  'databrain-pre.woa.com',
  'databrain-global-pre.woa.com',
  'databrain-global-pre.intlgame.com',
  'databrain-pre.intlgame.com',
  // test环境
  'databrain-test.woa.com',
  'databrain-global-test.intlgame.com',
  'databrain-test.intlgame.com',
  'databrain-test2.intlgame.com',
  'databrain-dev.intlgame.com',
];

/** 本地调试允许识别为 DataBrain 的宿主 */
const DATABRAIN_LOCAL_DEBUG_HOSTNAMES = ['localhost', '127.0.0.1'];

const getDatabrainPathSegments = (pathname = ''): string[] => {
  if (!pathname) {
    return [];
  }

  return pathname.split('/').filter(Boolean);
};

/**
 * 判断输入是否为“完整 URL”。
 *
 * 这里仅将 http/https 且包含 host 的地址视为完整 URL，避免把 mailto、javascript
 * 等仅包含协议的字符串误判为可解析页面地址。
 */
export const isCompleteHttpUrl = (url: string): boolean => {
  if (!url) {
    return false;
  }

  try {
    const urlObj = new URL(url);

    return ['http:', 'https:'].includes(urlObj.protocol) && !!urlObj.host;
  } catch (error) {
    return false;
  }
};

/** 判断宿主是否属于 DataBrain 体系（含本地调试宿主） */
export const isDatabrainHostname = (hostname = ''): boolean => {
  const normalizedHostname = hostname.toLowerCase();

  if (!normalizedHostname) {
    return false;
  }

  return (
    DATABRAIN_HOSTNAMES.includes(normalizedHostname) ||
    DATABRAIN_LOCAL_DEBUG_HOSTNAMES.includes(normalizedHostname) ||
    /^databrain-(?:test\d*|dev)\.(?:intlgame|woa)\.com$/i.test(normalizedHostname)
  );
};

/** 将输入 URL 统一解析为 URL 对象，兼容相对路径与绝对路径 */
export const getUrlObject = (url: string): URL | null => {
  if (!url) {
    return null;
  }

  try {
    return new URL(url, window.location.href);
  } catch (error) {
    return null;
  }
};

/** 判断 URL Host 是否属于 DataBrain 体系域名 */
const isDatabrainHost = (urlObj: URL, url: string): boolean => {
  if (!isCompleteHttpUrl(url)) {
    return false;
  }

  const { hostname } = urlObj;

  if (!hostname) {
    return false;
  }

  return isDatabrainHostname(hostname);
};

/** 复用同一个 URL 对象判断是否属于 DataBrain 系统 */
const isDatabrainUrlByUrlObject = (urlObj: URL | null, url: string): boolean => {
  if (!urlObj) {
    return false;
  }

  return isDatabrainHost(urlObj, url);
};

/** 从 URL pathname 中提取并归一 DataBrain 子系统 code */
const getCanonicalDatabrainSystemCodeByPathname = (pathname = ''): string => {
  if (!pathname) {
    return '';
  }

  const pathSegments = getDatabrainPathSegments(pathname);
  const firstSegment = pathSegments[0]?.toLowerCase() || '';
  const rawSystemCode = DATABRAIN_BASE_PATHS.includes(firstSegment) ? pathSegments[1] || '' : pathSegments[0] || '';
  const normalizedRawSystemCode = rawSystemCode.toLowerCase();

  if (!normalizedRawSystemCode) {
    return /^\/(?:v2|rebuildv2)?\/?$/i.test(pathname) ? DBSystemCode.Home : '';
  }

  return DATABRAIN_SYSTEM_CODE_MAP[normalizedRawSystemCode] || '';
};

/** 仅基于 pathname 推断 DataBrain 子系统 code，不依赖当前宿主环境 */
export const getDatabrainSystemCodeFromPath = (url: string): TDBSystemCode => {
  const urlObj = getUrlObject(url);

  if (!urlObj) {
    return '' as TDBSystemCode;
  }

  return getCanonicalDatabrainSystemCodeByPathname(urlObj.pathname) as TDBSystemCode;
};

/** 一次性解析 DataBrain URL 基础信息，避免重复创建 URL 对象 */
const getDatabrainUrlMeta = (
  url: string,
): {
  urlObj: URL | null;
  isDatabrain: boolean;
  systemCode: string;
} => {
  const urlObj = getUrlObject(url);
  const systemCode = getCanonicalDatabrainSystemCodeByPathname(urlObj?.pathname || '');
  const isRelativeDatabrain =
    !!systemCode &&
    !isCompleteHttpUrl(url) &&
    url.startsWith('/') &&
    !url.startsWith('//') &&
    isDatabrainHostname(window.location.hostname);
  const isDatabrain = !!systemCode && (isRelativeDatabrain || isDatabrainUrlByUrlObject(urlObj, url));

  if (!isDatabrain) {
    return {
      urlObj,
      isDatabrain,
      systemCode: '',
    };
  }

  return {
    urlObj,
    isDatabrain,
    systemCode,
  };
};

/** 判断输入 URL 是否属于 DataBrain 系统 */
export const isDatabrainUrl = (url: string): boolean => {
  const { isDatabrain } = getDatabrainUrlMeta(url);

  return isDatabrain;
};

/**
 * 从 DataBrain URL 中提取子系统 code。
 *
 * 兼容 `/v2/{system}`、`/rebuildv2/{system}` 和直接 `/{system}` 三种路径形式。
 */
export const getDatabrainSystemCode = (url: string): TDBSystemCode => {
  const { systemCode } = getDatabrainUrlMeta(url);

  return systemCode as TDBSystemCode;
};
